/* Homepage motion (loaded on the index template only): sections ease up into
   place as they scroll into view, with a small stagger inside grids. Content
   is fully visible without JS or with prefers-reduced-motion. */
(function () {
  if (window.__pphReveal) return;
  window.__pphReveal = true;
  if (!('IntersectionObserver' in window)) return;
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  // The hero (first screen) is not animated in: it must paint right away
  // instead of waiting for this deferred script (audit 2026-10-03, LCP).
  var SELECTORS = [
    '.pph-heading-row',
    '.pph-cats > *',
    '.pph-steps-images > *',
    '.pph-steps-grid > div:last-child',
    '.pph-products > *',
    '.pph-split-media',
    '.pph-split-body',
    '.pph-give',
    '.pph-news-box'
  ];

  function start() {
    var els = document.querySelectorAll(SELECTORS.join(','));
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        e.target.classList.add('is-in');
        io.unobserve(e.target);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    els.forEach(function (el) {
      var i = Array.prototype.indexOf.call(el.parentNode.children, el);
      el.style.setProperty('--pph-delay', Math.min(i, 6) * 70 + 'ms');
      el.classList.add('pph-reveal');
      io.observe(el);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
